// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"666b3011","410":"5972f298","557":"5a96f2c2","787":"451d88d8","795":"34f9558d","961":"15d6f9a3"}[chunkId] + ".chunk.js";
};